import { FilledInput, FormControl, FormHelperText, InputAdornment, InputLabel } from '@mui/material';
import useTailwindBrand from '../../Theme/useTailwindBrand';

interface Props {
    getTeachrPrice: any
    value: any | number
    label: string
    customPrice?: string
    name?: string
    disabled?: boolean
    error?: boolean
    errorMsg?: string
}

const PriceFields = (props: Props) => {
    const { classes } = useTailwindBrand();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.getTeachrPrice(e.target.value);
    };

    return (
        <div className={`relative w-full ${props?.customPrice}`}>
            <FormControl variant="filled" fullWidth>
                <InputLabel className={`${classes.fontFamily} ${props.error && props.errorMsg ? classes.error : classes.text} font-semibold ${props.label ? '' : 'hidden'}`}>
                    {props.label}
                </InputLabel>
                <FilledInput
                    type="number"
                    name={props.name}
                    placeholder="Ex : 30"
                    value={props.value ?? ''}
                    onChange={handleChange}
                    disabled={props.disabled}
                    error={(props.error && props.errorMsg) ? true : false}
                    className={`${classes.fontFamily} ${props.error && props.errorMsg ? classes.errorBorder + ' border-l-4' : 'border-gray-400'} bg-white rounded-md border`}
                    endAdornment={<InputAdornment position="end">€</InputAdornment>}
                />
            </FormControl>
            {props.error && props.errorMsg && (
                <FormHelperText className={`${classes.fontFamily} ${classes.error} italic font-semibold`}>
                    {props.errorMsg}
                </FormHelperText>
            )}
        </div>
    );
};

export default PriceFields;
